import { AvatarUpload, SelectInput, TextInput } from "components";
import { FormikProps } from "formik";
import { FC } from "react";

interface PartnerUserFormProps {
  form: FormikProps<{
    lastName: string;
    firstName: string;
    ghanaCardNumber: string;
    phoneNumber: string;
    emailAddress: string;
    role: string
    gender: string;
    profileImageUrl: string;
  }>;
}

export const PartnerUserForm: FC<PartnerUserFormProps> = ({ form }) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <span className="text-xs font-light">Staff Information</span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div>
            <AvatarUpload id="profileImageUrl" label="Photo" {...form} />
          </div>

          <div>
            <TextInput
              id="ghanaCardNumber"
              label="Ghana Card"
              type="text"
              placeholder="Ghana Card"
              required={true}
              {...form}
            />
          </div>

          <div>
            <TextInput
              id="lastName"
              label="Last Name"
              type="text"
              placeholder="e.g. Mensah"
              required
              {...form}
            />
          </div>

          <div>
            <TextInput
              id="firstName"
              label="Others Names"
              type="text"
              placeholder="e.g. Enoch Nana Nyankah"
              required
              {...form}
            />
          </div>

          <div>
            <TextInput
              id="phoneNumber"
              label="Phone Number"
              type="text"
              placeholder="e.g. 0550123292"
              required
              {...form}
            />
          </div>

          <div>
            <TextInput
              id="emailAddress"
              label="Email Address"
              type="email"
              placeholder="e.g. nyankahmensah@gmail.com"
              required
              {...form}
            />
          </div>
          <div>
            <SelectInput
              id="gender"
              label="Gender"
              options={[
                { label: "--- Select Gender ---", value: "" },
                { label: "Male", value: "Male" },
                { label: "Female", value: "Female" },
              ]}
              required
              {...form}
            />
          </div>
          <div>
            <SelectInput
              id="role"
              label="Role"
              options={[
                { label: "--- Select Role ---", value: "" },
                { label: "Super Admin", value: "Super" },
                { label: "Admin", value: "Admin" },
              ]}
              required
              {...form}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerUserForm;
